<template>
  <div id="app">
    <xes-center-navigator
      :activeIndex="4"
      domain="ocenter"
      fixed
    />
    <xes-mall-sidebar
      :qiyuParams="qiyuParams"
      :sideList="SIDE_BAR_DATA"
    />
    <router-view></router-view>
    <xDialog></xDialog>
  </div>
</template>

<script>
import { SIDE_BAR_DATA } from "~common/assets/js/const.js"
import xDialog from '~common/components/mainSite/dialog.vue'
import config from './config'
import { getQueryParamValue } from '~common/util/assist.js'
export default {
  name: 'app',
  components: {
    xDialog
    // iheader
  },
  data () {
    return {
      SIDE_BAR_DATA,
      qiyuParams: {
        key: config.QiYuKey
      }
    }
  },
  created () {
    const orderNum = getQueryParamValue('orderNum')
    if (orderNum) {
      this.qiyuParams.orderId = orderNum
    }
    this.$router.beforeEach((to, from, next) => {
      if (to.name === 'orderDetail') {
        this.qiyuParams.orderId = getQueryParamValue('orderNum')
      } else {
        this.qiyuParams = {
          key: config.QiYuKey
        }
      }
      next()
    })
  }
}
</script>
<style lang="less">
/* 隐藏购物车 */
#xes-global-head {
  .global {
    &-header {
      display: none;
    }
    &-nav {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// module/order/src/App.vue